module.exports = "/_next/static/images/st-9fb0ea9d11c83a9a621f3ca700c06386.svg";